import {faBolt} from "@fortawesome/free-solid-svg-icons";

export default faBolt;
